<script lang="ts">
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import { faPenSquare, faCalendarAlt, faUser, faExchangeAlt } from '@fortawesome/free-solid-svg-icons'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import { BalanceResult } from '../../modules/posApi/balance-results/balance-result'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import dayjs from 'dayjs'
    import type { Appointment } from '../../modules/schedulerApi/appointments/appointment'
    import { AppointmentStatusFriendly } from '../../modules/schedulerApi/appointments/appointments.enum'
    import AppointmentForm from '../agenda/appointment-form.svelte'
    import Popover from '../_common/popover.svelte'
    import PersonTabBalanceForm from '../persons/person-tab-balance-form.svelte'
    import Zdrop from '../_common/z/zdrop.svelte'
    import type { ZdropInterface } from '../_common/z/zdrop.interface'
    import AppointmentSign from '../agenda/appointment-sign.svelte'
    import { onMount } from 'svelte'
    import { GridButton } from '../_common/z/zgrid'

    export let personId: string = null

    let show: boolean = false
    let showFinished: boolean = false

    let notChargedStatus = ['agendamento_remarcado', 'agendamento_cancelado_usuario', 'agendamento_cancelado_empresa', 'agendamento_excluido']

    let person: Person = null

    onMount(async () => {
        if (personId) {
            person = await window.api.events.persons.getOne(personId)
            await loadPersonBalance()
        }
    })

    interface BalanceInterface {
        invoiceId: string
        name: string
        type: 'package' | 'service'
        serviceId: string // pagackageServiceId / o serviço que é o título do pacote
        createdAt: Date
        pending: number
        balances: { balanceResultId: string; balanceResult: BalanceResult; appointments: Appointment[] }[]
        step: number
    }

    let balanceGroup: BalanceInterface[] = []
    function generateBalance(balanceResult: BalanceResult[]) {
        let _balanceGrup: BalanceInterface[] = []
        for (const item of balanceResult) {
            // se é um pacote agrupa os serviços do pacote considerando inclusive o invoiceId
            if (item.packageServiceId) {
                console.log('with packageServiceId', item)
                let balance: BalanceInterface = _balanceGrup.find((b) => b.invoiceId === item.invoiceId && b.serviceId === item.packageServiceId)
                if (!balance) {
                    balance = {
                        invoiceId: item.invoiceId,
                        type: 'package',
                        name: item.packageService?.name,
                        serviceId: item.packageServiceId,
                        pending: 0,
                        createdAt: item.purchaseAt,
                        balances: [],
                        step: 1,
                    }
                    _balanceGrup.push(balance)
                }
                balance.pending += item.scheduled + item.unscheduled
                balance.balances.push({ balanceResult: item, balanceResultId: item.balanceResultId, appointments: [] })
            } else {
                console.log('no packageServiceId', item)
                // se é um item que não seja um pacote (serviço comprado avulso em 1 ou mais quantidades)
                let balance: BalanceInterface = {
                    invoiceId: item.invoiceId,
                    type: 'service',
                    name: item.service?.name || '-',
                    serviceId: item.serviceId,
                    createdAt: item.purchaseAt,
                    pending: item.scheduled + item.unscheduled,
                    balances: [{ balanceResult: item, balanceResultId: item.balanceResultId, appointments: [] }],
                    step: 1,
                }
                _balanceGrup.push(balance)
            }
        }
        _balanceGrup.sort((el) => (el.type === 'service' ? 1 : -1))
        balanceGroup = _balanceGrup
        console.log('balances', balanceGroup)
    }

    let balanceResult: BalanceResult[] = []
    async function loadPersonBalance() {
        balanceResult = []
        balanceGroup = []
        if (!person) return
        show = true
        let _balanceResult: BalanceResult[] = await window.api.pos.balanceResults.getAll({ personId: person.personId })
        _balanceResult = await window.api.utils.utils.assignPersonsFromObject(_balanceResult)
        _balanceResult = await window.api.utils.utils.assignServicesFromObject(_balanceResult)
        _balanceResult = await window.api.utils.utils.assignServicesFromObject(_balanceResult, false, 'packageService') // refere-se ao pacote (o serviço que representa o nome do pacote)
        for (const balance of _balanceResult) {
            balance.parentServicesOnInvoicesId
        }
        _balanceResult.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        balanceResult = _balanceResult
        console.log('balanceResult', balanceResult)
        generateBalance(balanceResult)
        show = false
    }

    async function showAppointments(bal: BalanceInterface) {
        bal.balances.map((b) => {
            b.appointments = []
        })
        show = true
        let appointments: Appointment[] = await window.api.schedulers.appointments.getAll({
            personId: person.personId,
            serviceId: [...bal.balances.map((b) => b.balanceResult.serviceId)],
        })
        console.log('appointments', appointments)
        show = false
        for (const appointment of appointments) {
            for (const item of appointment.items) {
                let found
                // temos 2 grupos de saldo: seviço avulso e pacotes. se parentServicesOnInvoicesId possuir valor é pacote. caso contrário é avulso (seja comprado de 1 em 1, ou comprado de 10 em 10).
                found = bal.balances.find(
                    (b) => b.balanceResult.serviceId === item.serviceId && b.balanceResult.parentServicesOnInvoicesId === item.parentServicesOnInvoicesId,
                )
                if (!found) continue
                found.appointments.push(appointment)
            }
        }

        console.log('balanceGroupAndServices', balanceGroup)
        bal.step = 2
        balanceGroup = balanceGroup
    }

    async function showBalance(balance: BalanceInterface) {
        balanceGroup = balanceGroup
        balance.step = 1
    }

    function showFinishedOnChange() {
        balanceGroup = balanceGroup
    }

    function getBarSize(item: BalanceResult) {
        const total = item.purchased + item.adjustments
        if (total === 0) return 100
        const result = (100 / total) * item.consumed
        return result > 100 ? 100 : result
    }

    let appointmentId: string = null
    let balance: BalanceInterface = null
    function showAppointment(data: { balance: BalanceInterface; appointmentId: string }) {
        balance = data.balance
        appointmentId = data.appointmentId
    }

    async function appointmentFormOnChange() {
        await showAppointments(balance)
    }

    async function appointmentFormOnClose() {
        closeAppointmentForm()
    }

    function closeAppointmentForm() {
        appointmentId = null
        balance = null
    }

    let balanceToAdjust: BalanceResult = null
    function adjustBalance(_balance: BalanceResult) {
        balanceToAdjust = _balance
    }

    function personTabBalanceFormOnChange() {
        balanceToAdjust = null
        loadPersonBalance()
    }

    let signAppointmentId: string = null
    function showSign(data: { appointmentId: string }) {
        signAppointmentId = data.appointmentId
    }
    function closeSign() {
        signAppointmentId = null
    }

    function expirationDate(item): { date: Date; expired: boolean } | null {
        if (item.balances.length === 0) return null
        if (!item.balances[0].balanceResult.expiresAt) return null
        const date = new Date(item.balances[0].balanceResult.expiresAt)
        const expired = date.getTime() < new Date().getTime()
        return { date, expired }
    }

    async function balanceRecalc() {
        if (!person) return
        show = true
        try {
            await window.api.pos.balanceResults.recalcBalance([person.personId])
            await new Promise((resolve) => setTimeout(resolve, 1500))
            await loadPersonBalance()
            window.alert('Saldos recalculados com sucesso!')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }
</script>

{#if appointmentId}
    <Popover title="Agendamento" width="1080px" height="80vh" on:close={closeAppointmentForm}>
        <!-- svelte-ignore missing-declaration -->
        <AppointmentForm on:change={appointmentFormOnChange} on:close:{appointmentFormOnClose} {appointmentId} />
    </Popover>
{/if}
{#if signAppointmentId}
    <Popover title="Assinatura" width="860px" height="460px" on:close={closeSign}>
        <AppointmentSign on:close={closeSign} appointmentId={signAppointmentId}></AppointmentSign>
    </Popover>
{/if}
{#if balanceToAdjust}
    <Popover
        title="Ajustes - Novo saldo"
        width="680px"
        on:close={() => {
            balanceToAdjust = null
        }}
    >
        <PersonTabBalanceForm
            on:change={personTabBalanceFormOnChange}
            balance={balanceToAdjust.unscheduled}
            personId={person.personId}
            serviceId={balanceToAdjust.serviceId}
            parentServicesOnInvoicesId={balanceToAdjust.parentServicesOnInvoicesId}
        />
    </Popover>
{/if}

<Content footer={true}>
    <Zact>
        {#if !personId}
            <div class="limit-w_500 flex-grow-1">
                <ZentitySelect fonte="pessoa" label="Cliente" bind:value={person} on:change={loadPersonBalance}></ZentitySelect>
            </div>
        {/if}
        {#if person}
            <Zbutton label="Recalcular saldos" on:click={balanceRecalc}></Zbutton>
        {/if}
        <div class="spacer"></div>
        <div>
            <Zinput type="toggle" bind:value={showFinished} label="Exibir finalizados" on:change={showFinishedOnChange}></Zinput>
        </div>
    </Zact>
    <Zframe class="h-space" title="Controle de Saldos">
        {#if !person}
            <div class="text-muted text-center mt-3 mb-5">Selecione uma pessoa para ver seu saldo.</div>
        {/if}
        <div class="cbal">
            <div class="cbal_person">
                <div class="cbal_person_in">
                    <div class="cbal_person_name">{person?.name || ''}</div>
                    <div class="cbal_person_acts">
                        <Zbutton icon={faUser} label="Pessoa" on:click={() => window.person('show', person?.personId, 2)}></Zbutton>
                    </div>
                </div>
                <div class="cbal_packs">
                    {#each balanceGroup as item}
                        {@const expiration = expirationDate(item)}
                        {#if showFinished || item.pending > 0}
                            <div class="cbal_pack">
                                <div class="cbal_pack_head">
                                    <div class="cbal_pack_title">
                                        <div class="badge badge_{item.type === 'package' ? 'package' : 'service'}">
                                            {item.type === 'package' ? 'pacote' : 'serviço'}
                                        </div>
                                        <div>{item.name}</div>
                                    </div>
                                    {#if item.type === 'package'}
                                        <div class="cbal_pack_date">
                                            <div class="badge">Data da compra:</div>
                                            <div>&nbsp;{dayjs(item.balances[0].balanceResult.purchaseAt).format('DD/MM/YYYY')}</div>
                                        </div>
                                    {/if}
                                    {#if expiration}
                                        <div class="cbal_pack_date">
                                            <div class="badge">Vencimento:</div>
                                            <div>&nbsp;{dayjs(expiration.date).format('DD/MM/YYYY')}</div>
                                            {#if expiration.expired}
                                                <div class="cbal_pack_date-expired badge zbadge_danger">vencido</div>
                                            {/if}
                                        </div>
                                    {/if}
                                    <div class="spacer"></div>
                                    <div class="cbal_pack_acts">
                                        {#if item.step === 1}
                                            <Zbutton
                                                icon={faExchangeAlt}
                                                on:click={() => {
                                                    showAppointments(item)
                                                }}
                                            ></Zbutton>
                                        {:else}
                                            <Zbutton
                                                icon={faExchangeAlt}
                                                on:click={() => {
                                                    showBalance(item)
                                                }}
                                            ></Zbutton>
                                        {/if}
                                    </div>
                                </div>
                                <div class="cbal_pack_items">
                                    {#each item.balances as balance}
                                        <div class="cbal_pack_item">
                                            <div class="-item-title">
                                                <div class="badge">
                                                    {balance.balanceResult.service?.type === 'package'
                                                        ? 'pacote'
                                                        : balance.balanceResult.service?.type === 'product'
                                                          ? 'produto'
                                                          : 'serviço'}
                                                </div>
                                                <div>&nbsp;{balance.balanceResult.service?.name || '-'}</div>
                                            </div>
                                            <div class="-item-content">
                                                <div class="-bar">
                                                    <div class="-label_from">1</div>
                                                    <div class="-bar-element">
                                                        <div style="width:{getBarSize(balance.balanceResult)}%;" class="-bar-element_in"></div>
                                                    </div>
                                                    <div class="-label_to">{balance.balanceResult.purchased + balance.balanceResult.adjustments}</div>
                                                </div>
                                                <div class="-details">
                                                    {#if item.step === 1}
                                                        <div class="-item">
                                                            <div class="-label">Adquirido</div>
                                                            <div class="-total">
                                                                <div class="-total_in">
                                                                    {balance.balanceResult.purchased}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="-item">
                                                            <div class="-label">Ajustes</div>
                                                            <div class="-total">
                                                                <div class="-total_in">
                                                                    {balance.balanceResult.adjustments}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="-item">
                                                            <div class="-label">Consumido</div>
                                                            <div class="-total"><div class="-total_in">{balance.balanceResult.consumed}</div></div>
                                                        </div>
                                                        <div class="-item">
                                                            <div class="-label">Agendado</div>
                                                            <div class="-total"><div class="-total_in">{balance.balanceResult.scheduled}</div></div>
                                                        </div>
                                                        <div class="-item">
                                                            <div class="-label">Falta agendar</div>
                                                            <div class="-total"><div class="-total_in">{balance.balanceResult.unscheduled}</div></div>
                                                        </div>
                                                    {:else}
                                                        {#each balance.appointments as appointment}
                                                            <Zdrop
                                                                class="-appointment {appointment.status} {notChargedStatus.includes(appointment.status)
                                                                    ? '-not-charged'
                                                                    : ''}"
                                                                menu={{
                                                                    position: 'flow',
                                                                    format: 'circle',
                                                                    buttons: [
                                                                        {
                                                                            callback: showAppointment,
                                                                            icon: faCalendarAlt,
                                                                            label: 'Abrir agendamento',
                                                                            data: { balance: item, appointmentId: appointment.appointmentId },
                                                                        },
                                                                        {
                                                                            callback: showSign,
                                                                            icon: faPenSquare,
                                                                            label: 'Assinatura',
                                                                            data: { appointmentId: appointment.appointmentId },
                                                                        },
                                                                    ],
                                                                }}
                                                            >
                                                                <div class="-date">{dayjs(appointment.start).format('DD/MM/YY')}</div>
                                                            </Zdrop>
                                                        {/each}
                                                        {#if balance.balanceResult.unscheduled > 0}
                                                            {#each Array(balance.balanceResult.unscheduled) as _, empty}
                                                                <div class="-appointment agendamento_pendente" title="">
                                                                    <div class="-date"></div>
                                                                </div>
                                                            {/each}
                                                        {/if}
                                                    {/if}
                                                </div>
                                                {#if item.step === 1}
                                                    <div class="-item-acts">
                                                        <!-- <button class="btn btn-sm btn-secondary">Histórico</button> -->
                                                        <button class="btn btn-sm btn-outline-secondary" on:click={() => adjustBalance(balance.balanceResult)}
                                                            >Ajustar</button
                                                        >
                                                    </div>
                                                {/if}
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                    {/each}
                </div>
            </div>
        </div></Zframe
    >
    <LoadSpinner {show} />
</Content>
